module.exports = __webpack_public_path__ + "img/enterprise-main02.78b0657b.png";